import app from 'flarum/forum/app';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';


app.initializers.add('indigo/flarum-ext-auth0-saw', () => {
  console.log('[indigo/flarum-ext-auth0-saw] Hello, forum!');

  document.addEventListener('DOMContentLoaded', function() {
  
	document.querySelector("li.item-logOut button.hasIcon").addEventListener("click", (e) => {
		//e.preventDefault();
		//alert('testando');
        	//window.location.href("https://vocallcontact.us.auth0.com/v2/logout?returnTo=https%3A%2F%2Fmelhorias.eox.com.br%2F&client_id=3bHYaEvkSwo0I7jf3eUKZqtNQ9vfDL1z")

	var banner = document.querySelector("a.TagCategory-content.TagCategory-content-manual-do-administrador")
	banner.addEventListener("mouseover", showTooltip);

	function showTooltip() {
        	console.log('Mouse is over the banner!')
	}





  })


  function addButton(items: ItemList<any>) {
	items.add('indigo/flarum-ext-auth0-saw', Button.component({
		icon: 'fas fa-door-open',
		className: 'logoutBtn',
		onclick: () => {
			alert('vc clicou no logout');
			//m.route.set("/all")
			window.location.href = "https://vocallcontact.us.auth0.com/v2/logout";
		},		
								 
								 
	}, 'logout-btn', 101)) }
  


//  extend(SessionDropdown.prototype, 'items', addButton);

  });
});


